import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BudgetsPage from './pages/BudgetsPage';
import ProjectsPage from './pages/ProjectsPage';
import FleetPage from './pages/FleetPage';
import EmployeesPage from './pages/EmployeesPage';
import MaterialsPage from './pages/MaterialsPage';
import FinancialPage from './pages/FinancialPage';
import SettingsPage from './pages/SettingsPage';
import ClientPortalPage from './pages/ClientPortalPage';
import BudgetPortalPage from './pages/BudgetPortalPage';
import PurchasesPage from './pages/PurchasesPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F7F8FA' }}><div className="pro-card-padded text-center p-8"><div className="w-8 h-8 border-3 border-gray-300 border-t-blue-600 rounded-full animate-spin mx-auto mb-3" /><p className="text-sm font-medium">A carregar...</p></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

import SuppliersPage from './pages/SuppliersPage';
import ComparisonMapsPage from './pages/ComparisonMapsPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/portal/:projectId" element={<ClientPortalPage />} />
      <Route path="/orcamento/:linkId" element={<BudgetPortalPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="orcamentos" element={<BudgetsPage />} />
        <Route path="obras" element={<ProjectsPage />} />
        <Route path="frota" element={<FleetPage />} />
        <Route path="funcionarios" element={<EmployeesPage />} />
        <Route path="materiais" element={<MaterialsPage />} />
        <Route path="fornecedores" element={<SuppliersPage />} />
        <Route path="mapas-comparativos" element={<ComparisonMapsPage />} />
        <Route path="compras" element={<PurchasesPage />} />
        <Route path="financeiro" element={<FinancialPage />} />
        <Route path="configuracoes" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AuthProvider><BrowserRouter><AppRoutes /></BrowserRouter></AuthProvider>;
}
